import { render, staticRenderFns } from "./optimiserStockAllocationPage.vue?vue&type=template&id=49afc109&scoped=true&"
import script from "./optimiserStockAllocationPage.vue?vue&type=script&lang=js&"
export * from "./optimiserStockAllocationPage.vue?vue&type=script&lang=js&"
import style0 from "./optimiserStockAllocationPage.vue?vue&type=style&index=0&id=49afc109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49afc109",
  null
  
)

export default component.exports